export default __webpack_public_path__ + "static/media/Hormone_Mobile@2x.db96d4ee.png";